import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { Link, LinkProps } from 'react-router-dom';

type NotesIconLinkProps = LinkProps & {
  label?: string;
};

export function NotesIconLink({ label = 'Anotações', className = '', ...props }: NotesIconLinkProps) {
  return (
    <Link
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-secondary-100 hover:text-secondary-800 ${className}`}
      {...props}
    >
      <PencilSquareIcon className="h-5 w-5" />
    </Link>
  );
}
